import BaseButton from 'core/buttons/base-button';
import PropTypes from 'prop-types';
import { RightChevronIcon } from 'components/icons';
import SelectInput from 'components/home/lead-form/inputs/select-input';
import styles from 'styles/LeadForm.module.scss';
import TextInput from 'components/home/lead-form//inputs/text-input';
import { useState } from 'react';
import { useTranslations } from 'next-intl';

const SelectCPTypeContent = ({
    typeList,
    onSubmit
}) => {
    const [type, setType] = useState(null);
    const [zipCode, setZipCode] = useState('');
    const t = useTranslations('lead-form');

    function callback () {
        onSubmit && onSubmit({ type, zipCode });
    };

    return (
        <>
            <div className={styles.name_email_form}>
                <div className={styles.fields}>
                    <TextInput
                        fieldName="cp"
                        placeholder={t('fields.zip-code-lbl')}
                        setValue={setZipCode}
                        value={zipCode}
                        focus
                    />
                    <SelectInput
                        placeholder={t('fields.select-type-lbl')}
                        optionsList={typeList}
                        selectedValue={type}
                        selectHandler={setType}
                    />
                </div>
                <BaseButton
                    label={t('buttons.continue-lbl')}
                    divClass={styles.form_button_wrapper}
                    buttonClass={styles.form_button}
                    onClick={callback}
                    endIcon={<RightChevronIcon width={12} height={12} />}
                />
            </div>
        </>
    );
};

SelectCPTypeContent.propTypes = {
    typeList: PropTypes.arrayOf(PropTypes.string).isRequired,
    onSubmit: PropTypes.func
};

export default SelectCPTypeContent;
